import React from "react";
var __jsx = React.createElement;
import { faCalendar, faClipboardList, faFileLines } from "@fortawesome/pro-regular-svg-icons";
import { getFormattedDate, normalizeUTCString } from "../../utils";
import AwesomeIcon from "../AwesomeIcon";
import { format, parseISO } from "date-fns";
import { t } from "i18next";
import Loader from "../Loader";
function formatTimestamp(timestamp) {
  try {
    return format(parseISO(timestamp), "h:mm aaa, d MMM yyyy");
  } catch (_unused) {
    return timestamp;
  }
}
function RecordRow(_ref) {
  var icon = _ref.icon,
    name = _ref.name,
    date = _ref.date,
    onViewRecords = _ref.onViewRecords;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between px-4 py-[10px] bg-[#f3f4f4] dark:bg-gray-900 rounded-[4px] cursor-pointer",
    onClick: onViewRecords
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2 min-w-0"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: icon,
    className: "text-gray-900 dark:text-gray-100 shrink-0",
    size: "sm"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-md font-medium text-gray-900 dark:text-gray-100 truncate",
    title: name
  }, name)), /*#__PURE__*/React.createElement("span", {
    className: "text-sm italic text-gray-900 dark:text-gray-100 shrink-0 ml-3"
  }, formatTimestamp(date)));
}
export function LinkedRecordsPanel(_ref2) {
  var linkedResources = _ref2.linkedResources,
    reports = _ref2.reports,
    appointments = _ref2.appointments,
    encounters = _ref2.encounters,
    onAddRecords = _ref2.onAddRecords,
    onViewRecords = _ref2.onViewRecords,
    isLoading = _ref2.isLoading;
  var hasLinkedRecords = linkedResources.reports.length > 0 || linkedResources.appointments.length > 0 || linkedResources.encounters.length > 0;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 pt-3 pb-[10px] px-4 rounded-[4px] border-[0.5px] border-gray-300 dark:border-gray-600"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-md text-gray-700 dark:text-gray-400 uppercase tracking-[0.16px]"
  }, t("label.linked_patient_records")), /*#__PURE__*/React.createElement("button", {
    onClick: onAddRecords,
    className: "text-[12px] text-teal-500 dark:text-teal-400 underline underline-offset-2 whitespace-nowrap"
  }, t("label.add_records"))), /*#__PURE__*/React.createElement("hr", {
    className: "border-t-[0.5px] border-gray-300 dark:border-gray-600"
  }), hasLinkedRecords && /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3"
  }, reports.map(function (r) {
    return /*#__PURE__*/React.createElement(RecordRow, {
      key: r.id,
      icon: faFileLines,
      name: r.heading,
      date: r.updated_at,
      onViewRecords: onViewRecords
    });
  }), appointments.map(function (a) {
    return /*#__PURE__*/React.createElement(RecordRow, {
      key: a.fhir_id,
      icon: faCalendar,
      name: a.appointment_type || "Appointment",
      date: getFormattedDate(normalizeUTCString(a.start_time), "d MMM yyyy", "-"),
      onViewRecords: onViewRecords
    });
  }), encounters.map(function (e) {
    return /*#__PURE__*/React.createElement(RecordRow, {
      key: e.fhir_id,
      icon: faClipboardList,
      name: "".concat(e.encounter_class, " | ").concat(e.encounter_type),
      date: getFormattedDate(normalizeUTCString(e.start_date), "d MMM yyyy", "-"),
      onViewRecords: onViewRecords
    });
  }), isLoading && /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center"
  }, /*#__PURE__*/React.createElement(Loader, {
    size: "small"
  }), /*#__PURE__*/React.createElement("span", {
    className: "ml-2 my-auto text-teal-500 dark:text-gray-500 text-sm"
  }, t("label.loading")))));
}